import editorRule from '@/components/atoms/editorRule'
import { PortableText } from 'next-sanity'

const Title = ({ text }) => {
  const base =
    'relative w-full text-subheadingMobile md:text-headingCardsDesktop text-olive font-ttDrugsTrial'

  return (
    <div className={base}>
      <PortableText value={text} components={editorRule()} />
    </div>
  )
}

export default Title
